<template>
  <v-app style="background:#e0e0e024;" >
    <h3 class="tetx-h5 mx-4 mt-4">Ordenes de restaurante</h3>
    <div class="mx-4 d-flex flex-row flex-wrap mb-6">
      <v-card class="mx-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 4</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Chilaquiles Rojos</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-1 my-1" max-width="320">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Mesa 5</v-card-title>

        <v-divider class="mx-4"></v-divider>

        <h5 class="mx-4 my-1">1.- Licuado de papaya</h5>
        <h5 class="mx-4 my-1">2.- Hamburguesa con queso</h5>



        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text >
            Atendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-app>

</template>

<style >
</style>


<script>
export default {
  name: "ComandaVirtual",
  components: {},
  props: [],
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  mounted() {},
  created() {},
};
</script>
